export default class ControlController {
  /** @ngInject */
  constructor(
    $log, $state
  ) {
    this.$log = $log;
    this.$state = $state;

    this.currentStateName = this.$state.current.name;
  }
}
